import { useTranslation } from "react-i18next";

const offlineTransactionStatusOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "SUCCESS",
      title: t("options.transStatus.success"),
      value: "SUCCESS",
    },
    {
      key: "SETTLED",
      title: t("options.transStatus.settled"),
      value: "SETTLED",
    },
    {
      key: "VOIDED",
      title: t("options.transStatus.voided"),
      value: "VOIDED",
    },
    {
      key: "DECLINED",
      title: t("options.transStatus.declined"),
      value: "DECLINED",
    },
    {
      key: "REVERSED",
      title: t("options.transStatus.reversed"),
      value: "REVERSED",
    },
    {
      key: "CANCELLED",
      title: t("options.transStatus.cancelled"),
      value: "CANCELLED",
    },
    {
      key: "PENDING",
      title: t("options.transStatus.pending"),
      value: "PENDING",
    },
    {
      key: "TIMEOUT",
      title: t("options.transStatus.timeout"),
      value: "TIMEOUT",
    },
    {
      key: "NONE",
      title: t("options.transStatus.none"),
      value: "NONE",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default offlineTransactionStatusOptions;
